import React, { useState, useRef, useEffect } from "react";
import {
  User,
  ShoppingCart,
  PhoneCall,
  ChevronDown,
  LogOut,
  Package,
  User2,
} from "lucide-react";
import { Link } from "react-router-dom";
import { AuthService } from "../../services/authService";
import { useCartCount } from "../../hooks/useCartCount";
import { motion } from "framer-motion";

const ActionIcons = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState("Usuário"); // Valor padrão
  const profileRef = useRef(null);
  const { count } = useCartCount();
  const [isAnimating, setIsAnimating] = useState(false);

  // Dispara a animação quando o count muda
  useEffect(() => {
    if (count > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("token");
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
    setIsProfileOpen(false);
    window.location.href = "/"; // Redireciona para a home (opcional)
  };

  const checkAuth = async () => {
    const isAuthenticated = await AuthService.isAuthenticated();
    setIsAuthenticated(isAuthenticated);
  };

  checkAuth();

  // Listener para fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex items-center gap-6">
      {/* Ícone de Atendimento */}
      <a
        href="https://wa.me/5561984497981"
        target="_blank"
        className="flex flex-col items-center bg-transparent border-none text-white transition-colors hover:text-green-400 no-underline relative"
        rel="noreferrer">
        <PhoneCall className="w-5 h-5" />
        <span className="text-xs mt-1">Atendimento</span>
      </a>
      {/* Ícone do Perfil */}
      <div className="relative" ref={profileRef}>
        <button
          onClick={() => setIsProfileOpen(!isProfileOpen)}
          className="flex flex-col items-center bg-transparent border-none text-white transition-colors hover:text-green-400 no-underline relative">
          <div className="flex items-center">
            <User className="w-5 h-5" />
            <ChevronDown
              className={`w-3 h-3 ml-1 transition-transform ${
                isProfileOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          <span className="text-xs mt-1">Minha Conta</span>
        </button>

        {/* Dropdown do Perfil */}
        {isProfileOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
            {isAuthenticated ? (
              <>
                <div className="px-4 py-3 border-b border-gray-200">
                  <p className="text-sm font-medium text-gray-800">
                    Olá, {userName}
                  </p>
                </div>
                <div className="py-1">
                  <Link
                    to="/minha-conta?tab=informacoes"
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center">
                    <User2 className="w-4 h-4 mr-2 text-gray-500" />
                    Minha Conta
                  </Link>
                  <Link
                    to="/minha-conta?tab=meus-pedidos"
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center">
                    <Package className="w-4 h-4 mr-2 text-gray-500" />
                    Meus Pedidos
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center">
                    <LogOut className="w-4 h-4 mr-2 text-gray-500" />
                    Sair
                  </button>
                </div>
              </>
            ) : (
              <div className="px-4 py-3">
                <p className="text-sm font-medium text-gray-800">
                  Olá, visitante
                </p>
                <p className="text-xs text-gray-500">
                  Faça{" "}
                  <a href="/login" className="text-green-500">
                    login
                  </a>{" "}
                  para continuar
                </p>
                <button className="w-full rounded-lg text-white font-bold bg-green-500 py-1 px-4 mt-2 hover:bg-green-600 transition-colors">
                  <a href="/Login">Login</a>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {/* Ícone do Carrinho */}
      <Link
        to="/cart"
        className="flex flex-col items-center bg-transparent border-none text-white transition-colors hover:text-green-400 no-underline relative">
        <motion.div
          className="relative"
          animate={{
            y: isAnimating ? [-3, 0, -1, 0] : 0,
            rotate: isAnimating ? [0, 5, -5, 0] : 0,
          }}
          transition={{ duration: 0.6, type: "tween" }}>
          <ShoppingCart className="w-5 h-5" />

          {count > 0 && (
            <motion.span
              key={count}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="absolute -top-1 -right-4 bg-red-500 text-white text-xs rounded-full px-2">
              {count}
            </motion.span>
          )}
        </motion.div>

        <span className="text-xs mt-1">Carrinho</span>
      </Link>
    </div>
  );
};

export default ActionIcons;
